export default {"src":"/_next/static/media/cohesive-search-and-discover.7aff8b4c.svg","height":922,"width":808,"blurWidth":0,"blurHeight":0};